<template>
  <div data-cy="footer" class="footer">
    <router-link
      data-cy="button-account"
      to="/user-profile"
      class="footer__icon-container"
    >
      <div class="footer__icon">
        <fa icon="user-circle" type="far"></fa>
      </div>

      <div class="footer__icon-text">Tài khoản</div>
    </router-link>

    <router-link
      data-cy="button-chat"
      to="/chat"
      class="footer__icon-container"
    >
      <div class="footer__icon">
        <fa icon="comment" type="far"></fa>
      </div>

      <div class="footer__icon-text">Tin nhắn</div>
    </router-link>

    <router-link
      data-cy="button-skin-profile"
      to="/skin-profile"
      class="footer__icon-container"
    >
      <div class="footer__icon footer__icon--skin-profile">
        <fa icon="notes-medical"></fa>
      </div>

      <div class="footer__icon-text">Hồ sơ da</div>
    </router-link>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
@Options({})
export default class Footer extends Vue {}
</script>

<style lang="scss" scoped>
$icon-height: 30px;

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid $grey;
  background: $white;
}

.footer__icon-container {
  flex: 1;
  padding-top: 10px;
  padding-bottom: 8px;
  color: $grey;
  text-decoration: none;
  font-size: 0.7rem;
}

.router-link-active {
  color: $black;
}

.footer__icon {
  display: inline-block;
  width: $icon-height;
  height: $icon-height;

  &--skin-profile {
    width: calc(0.75 * #{$icon-height});
    height: $icon-height;
  }
}
</style>
